namespace TabAurous {
    export let CommonProduct= {
        ProductId: 0,
        ProductCode: "",
        ProductName: "",
        ItemTypeId: 0,
        HasBom: false,
        CalcOnId: 0

    }
}